import { useCallback } from "react";

import {
  createFileRoute,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { Route as PhoneVerifyRoute } from "@app/navigation/routes/_private/phone-verify";
import { OtpDeliveryPageConnector } from "@pages/otp-delivery";

export const Route = createFileRoute("/_private/otp-delivery")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const navigate = useNavigate();

  const handleGoVerifyPhone = useCallback(async () => {
    await navigate({ to: PhoneVerifyRoute.fullPath });
  }, [navigate]);

  return (
    <OtpDeliveryPageConnector
      onGoBack={router.history.back}
      onGoVerifyPhone={handleGoVerifyPhone}
    />
  );
}
